<template>
    <nav class="navigation navigation--small navigation--inner"> 
        <ul class="navigation__list">
            <li class="navigation__item" @click.stop="show = !show">
                <a class="navigation__button" :class="{ 'navigation__button--active': show }"><i class="fa fa-sliders navigation__icon" aria-hidden="true"></i> {{locales.common && locales.common.filters}}</a>
            </li>

            <li class="navigation__item">
                <a class="navigation__button" @click="setLayout('list')" :class="{ 'navigation__button--active': layout === 'list' }"><i class="fa fa-list" aria-hidden="true"></i></a>
            </li>

            <li class="navigation__item navigation__item--desktop">
                <a class="navigation__button" @click="setLayout('grid')" :class="{ 'navigation__button--active': layout === 'grid' }"><i class="fa fa-th-large" aria-hidden="true"></i></a>
            </li>

            <li class="navigation__item--spacer"></li>

            <li class="navigation__item">
                <span class="navigation__label">{{locales.common && locales.common.order_by}}:</span>

                <select class="navigation__select" name="order" form="filters" @change="sort">
                    <option value="published_at_desc" :selected="order == 'published_at_desc'">{{locales.filters && locales.filters.latest_first}}</option>
                    <option value="published_at_asc" :selected="order == 'published_at_asc'">{{locales.filters && locales.filters.oldest_first}}</option>
                    <option value="location_asc" :selected="order == 'location_asc'">{{locales.filters && locales.filters.location_a_z}}</option>
                    <option value="location_desc" :selected="order == 'location_desc'">{{locales.filters && locales.filters.location_z_a}}</option>
                    <option value="price_asc" :selected="order == 'price_asc'">{{locales.filters && locales.filters.price_low_to_high}}</option>
                    <option value="price_desc" :selected="order == 'price_desc'">{{locales.filters && locales.filters.price_high_to_low}}</option>
                    <option value="number_of_rooms_asc" :selected="order == 'number_of_rooms_desc'">{{locales.filters && locales.filters.rooms_low_to_high}}</option>
                    <option value="number_of_rooms_desc" :selected="order == 'number_of_rooms_asc'">{{locales.filters && locales.filters.rooms_high_to_low}}</option>
                </select>
            </li>
        </ul>

        <div class="filters filters-public" v-if="show" @click.stop>
            <form class="filters__dropdown" id="filters">
                <ul class="filters__list">
                    <li class="filters__item">
                        <label class="filters__label">
                            {{locales.properties && locales.properties.location}}
                        </label>

                        <v-autocomplete-public
                            style="display:inline-block; min-height:10px;"
                            class="filters__textfield"
                            label=""
                            v-model="old.location"
                            :initial="old['_labels[location]']"
                            name='location' endpoint="/admin/autocomplete/locations"
                            :is-phrase-model="true"
                            :resolve="(item) => item.name">
                        </v-autocomplete-public>
                    </li>
                    <template v-if="website == 'athome'">
                        <li class="filters__item">
                            <label class="filters__label">
                                {{locales.properties && locales.properties.type}}
                            </label>

                            <select class="filters__textfield" name="category">
                                <option value="all" :selected="old.category == `all`">
                                    {{ locales.common && locales.common.all }}
                                </option>
                                <option v-for="category in categories" :value="category.id" :selected="old.category == category.id">
                                    {{ category.value }}
                                </option>
                            </select>
                        </li>

                        <li class="filters__item">
                            <label class="filters__label">
                                {{locales.properties && locales.properties.delivery}}
                            </label>

                            <select class="filters__textfield" name="furnishing">
                                <option value="all" :selected="old.furnishing == 'all'">
                                    {{locales.common && locales.common.all}}
                                </option>                            
                                <option v-for="furnishing in metadata.filter(index => index.key === 'furnishing')" v-if='furnishing.attribute.slug!=="more_possibilities"' :value="furnishing.id" :selected="old.furnishing == furnishing.id">
                                    {{ furnishing.value }}
                                </option>
                            </select>
                        </li>

                        <li class="filters__item">
                            <label class="filters__label">
                                {{locales.properties && locales.properties.bedrooms}}
                            </label>

                            <input class="filters__textfield" type="text" name="number_of_bedrooms" :value="old.number_of_bedrooms">
                        </li>
                    </template>
                </ul>

                <ul class="filters__list">
                    <li class="filters__item">
                        <label class="filters__label">
                            {{locales.properties && locales.properties.distance}}
                        </label>

                        <select class="filters__textfield" name="ray">
                            <option :value="0" :selected="old.ray == 0">
                                0 km
                            </option>

                            <option :value="5" :selected="old.ray == 5">
                                < 5 km
                            </option>

                            <option :value="10" :selected="old.ray == 10">
                                < 10 km
                            </option>

                            <option :value="20" :selected="old.ray == 20">
                                < 20 km
                            </option>

                            <option :value="40" :selected="old.ray == 40">
                                < 40 km
                            </option>
                        </select>
                    </li>
                    <template v-if="website == 'athome'">
                        <li class="filters__item">
                            <label class="filters__label">
                                {{locales.properties && locales.properties.price}}
                            </label>

                            <input class="filters__textfield filters__textfield--small" type="text" name="min_price" :value="old.min_price">

                            <div class="filters__placeholder">-</div>

                            <input class="filters__textfield filters__textfield--small" type="text" name="max_price" :value="old.max_price">
                        </li>

                        <li class="filters__item">
                            <label class="filters__label">
                                {{locales.properties && locales.properties.area}}
                            </label>

                            <input class="filters__textfield" type="text" name="area" :value="old.area">
                        </li>
                    </template>

                    <li class="filters__item">
                        <label class="filters__label filters__label--has-checkbox">
                            <input class="filters__checkbox" type="checkbox" name="available_only" :checked="old.available_only"> {{locales.properties && locales.properties.show_only_available_properties}}
                        </label>
                    </li>

                    <li class="filters__item filters__item--to-right filters__item--align-right">
                        <button class="filters__button" type="submit">
                            {{locales.common && locales.common.search}}
                        </button>
                    </li>
                </ul>
            </form>
        </div>
    </nav>
</template>

<script>
import queryString from 'query-string';
import { mapGetters, mapActions } from 'vuex';
import _ from 'lodash';
import $ from 'jquery';
import VAutocompletePublic from './../admin/components/VAutocompletePublic';
export default {
  data() {
    return {
      show: false,
      old: null,
      order: queryString.parse(window.location.search).order
    };
  },
  computed: {
    ...mapGetters(['metadata', 'locales']),
    layout() {
      return this.$store.getters.getPropertiesLayout;
    },
    website: function () {
        if (this.websiteId == 1) {
            return 'athome'
        } else {
            return 'staffhousing'
        }
    },
    categories() {
      return this.$store.getters.getPropertiesCategories;
    }
  },
  components: {
    VAutocompletePublic
  },
  props: {
    websiteId: {
        default: '',
        type: String
    }
  },
  methods: {
    setLayout(layout) {
      this.$store.commit('SET_PROPERTIES_LAYOUT', layout);
    },
    sort(event) {
      let search = queryString.parse(window.location.search);
      search.order = event.target.value;
      window.location.search = queryString.stringify(search);
    }
  },
  created() {
    document.addEventListener('click', () => {
      this.show = false;
    });

    this.old = queryString.parse(location.search);
  }
};
</script>

<style lang="scss">
.navigation__item--desktop {
  @media screen and (max-width: 767px) {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/PropertySearchControl.vue